import { MultiValueTextField } from '@joor/design-system'
import styled from 'styled-components'

export const StyledMultiValueInput = styled(MultiValueTextField)`
  width: 100%;
  max-width: unset;
  > div {
    border: none;
    padding: 5px 8px;
  }
`
